export default __webpack_public_path__ + "static/media/approve1.d01643db.svg";